import { boot } from './core/boot';

boot();

export {};
